var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-info",on:{"mouseenter":_vm.toggle,"mouseleave":_vm.toggle}},[_c('button',{staticClass:"app-info__icon",attrs:{"type":"button"}},[_c('span',{staticClass:"far",class:[_vm.faIcon]})])])
}
var staticRenderFns = []

export { render, staticRenderFns }